"use strict";
var Observable_1 = require('../../Observable');
var bufferToggle_1 = require('../../operator/bufferToggle');
Observable_1.Observable.prototype.bufferToggle = bufferToggle_1.bufferToggle;
//# sourceMappingURL=bufferToggle.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/bufferToggle.js
 ** module id = 379
 ** module chunks = 9
 **/